import { render } from "./AddDynamicPlayerSourceModal.vue?vue&type=template&id=1a25daba"
import script from "./AddDynamicPlayerSourceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddDynamicPlayerSourceModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/AddDynamicPlayerSourceModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a25daba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a25daba', __exports__)) {
    api.reload('1a25daba', __exports__)
  }
  
  module.hot.accept("./AddDynamicPlayerSourceModal.vue?vue&type=template&id=1a25daba", () => {
    api.rerender('1a25daba', render)
  })

}


export default __exports__